// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import VueResource from 'vue-resource';

import {checkUserLoginStatus} from './api';

let SEC = require('common/js/utils/core.js');

Vue.use(VueResource);
Vue.http.options.emulateJSON = true;
Vue.http.options.xhr = {withCredentials: true};
Vue.http.interceptors.push(function(request, next) {//拦截器
    request.credentials = true; // 跨域携带cookie
    next();
});

// 判断用户登录状态
let upk = SEC.cookie.get('Sid') || '';

if (!upk) {
  const href = encodeURIComponent(window.location.href);
  // 没有upk，直接跳转到登录页
  window.location.href = `//m.secoo.com/v1/login/?redirect_uri=${href}`;
} else {
  // 有upk，检测登录是否有效
  checkUserLoginStatus(upk).then(res => {

    const {retCode} = res.data;

    // 0-成功(会话有效) 1300-会话失效
    if (retCode === 0) {
      Vue.config.productionTip = false

      /* eslint-disable no-new */
      new Vue({
        el: '#app',
        router,
        template: '<App/>',
        components: { App }
      });
    } else {
      const href = encodeURIComponent(window.location.href);
      window.location.href = `//m.secoo.com/v1/login/?redirect_uri=${href}`;
    }
  }).catch(() => {

  });
}



// WEBPACK FOOTER //
// ./src/main.js